import { render, staticRenderFns } from "./SearchJournals.vue?vue&type=template&id=a9f6db84&scoped=true"
import script from "./SearchJournals.vue?vue&type=script&lang=js"
export * from "./SearchJournals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f6db84",
  null
  
)

export default component.exports